import { usePrimaryPage } from '@/PageManager'
import { useAtomValue } from 'jotai'
import { filteredNewNotificationsAtom } from '@/atoms/notifications'
import { hideNotificationsAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { BellIcon } from '@hugeicons/core-free-icons'
import BottomNavigationBarItem from './BottomNavigationBarItem'

export default function NotificationsButton() {
  const { navigate, current, display } = usePrimaryPage()
  const hasNewNotification = useAtomValue(filteredNewNotificationsAtom) > 0
  const hideNotifications = useAtomValue(hideNotificationsAtom)
  if (hideNotifications) return null

  return (
    <BottomNavigationBarItem
      active={current === 'notifications' && display}
      onClick={() => navigate('notifications')}
    >
      <div className="relative">
        <HugeiconsIcon icon={BellIcon} />
        {hasNewNotification && (
          <div className="absolute -top-0.5 right-0.5 w-2 h-2 ring-2 ring-background bg-primary rounded-full" />
        )}
      </div>
    </BottomNavigationBarItem>
  )
}
